import React from 'react';
import Menu from './lis-nav-component';
import SessionSelector from './lis-session-selector';
import Popup from './lis-popup-component';
import Profile from './lis-profile-component';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { authActionCreators } from '../../../stores/lis-auth-store';
import { navActionCreators } from '../../../stores/lis-nav-store';
import { sessionActionCreators } from '../../../stores/lis-session-store';
import ToastContainer from './lis-toast-component';
import IconLinks from './lis-icon-links-component';

class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            helpBanner: !localStorage.getItem("HELP_BANNER_DISMISSED"),
            showPopup: false,
            popupMessage: '',
            isIdle: false,
            isAriaExpanded: false,
            isAriaHidden: true,
            isMenuVisible: false,
            isOpen: false,
            overrideSession: ""
        };

        this.dismissHelpBanner = this.dismissHelpBanner.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isIdle && this.props.isIdle) {
            this.setState({
                showPopup: true
            })
        }

        if (this.props.location.pathname === "/home" && prevProps.location.pathname !== "/home" && this.state.overrideSession === "") {
            let session = this.props.session.sessionList.find(x => x.IsDefault);
            if (session) {
                this.props.actions.changeSession(session.SessionCode)
                this.setState({ overrideSession: session })
            }
        } else if (this.state.overrideSession !== "") {
            this.setState({
                overrideSession: ""
            })
        }
    }

    logOutUser() {
        this.props.actions.logoutUser();
    }

    togglePopup() {
        this.setState(state => ({
            showPopup: !state.showPopup
        }));
    }

    slideoutToggle() {
        this.setState(prevState => ({
            isMenuVisible: !prevState.isMenuVisible,
            isAriaHidden: !prevState.isAriaHidden,
            isAriaExpanded: !prevState.isAriaExpanded,
            isOpen: !prevState.isOpen
        }));
    }

    dismissHelpBanner() {
        localStorage.setItem("HELP_BANNER_DISMISSED", true);
        this.setState({ helpBanner: false })
    }

    render() {
        const {
            popupMessage
        } = this.props;
        const { isOpen, isAriaHidden, isAriaExpanded, isMenuVisible, helpBanner } = this.state;

        return (
            <div className={isOpen ? 'open-state' : null}>
                {isOpen &&
                    <div className="slideout-overlay" onClick={this.slideoutToggle.bind(this)} />
                }
                {window.env?.APP_ENV?.toLowerCase() !== "production" && window.env?.API_SERVER?.toLowerCase() !== "https://lis.virginia.gov" && <div className="alert alert-warning mb-0"><b>This is a non-production environment</b>. This environment is NOT for public access. You may access LIS at <a href="https://lis.virginia.gov">LIS.virginia.gov</a>.</div>}
                {this.props.login.userClaims?.claims?.find(c => c.RoleName?.toLowerCase() === "admin") && (window.env?.APP_ENV?.toLowerCase() === "production" || window.env?.API_SERVER?.toLowerCase() === "https://lis.virginia.gov") && <div className="alert alert-danger mb-0"><b>PLEASE BE AWARE</b>: YOU ARE IN THE PRODUCTION LIS ENVIRONMENT AND ANY ACTIONS TAKEN WILL BE SUBMITTED IN THE PRODUCTION DATABASE.</div>}
                {helpBanner && <div className="help-banner"><button type="button" class="close" data-dismiss="alert" aria-label="Close" onClick={this.dismissHelpBanner}><span aria-hidden="true">×</span></button>Get acquainted with our new Virginia State Legislative Information System! <a href="https://help.lis.virginia.gov/start/index.asp" target="_blank" rel="noreferrer">LIS Learning Center</a></div>}
                <Menu slideoutToggle={this.slideoutToggle.bind(this)} isOpen={this.state.isOpen} session={this.props.session.sessionList.find(x => x.SessionCode === this.props.nav.session)} permissions={this.props.permissions} />
                <Profile
                    isMenuVisible={isMenuVisible}
                    isAriaExpanded={isAriaExpanded}
                    isAriaHidden={isAriaHidden}
                    slideoutToggle={this.slideoutToggle.bind(this)}
                    isOpen={isOpen}
                    slideout={true}
                    selectedSession={this.props.selectedSession}
                    permissions={this.props.permissions}
                />
                <SessionSelector overrideSession={this.state.overrideSession} />
                <ToastContainer toasts={this.props.nav.toasts} />
                <main>
                    <section>
                        <div className="full">
                            <div className="content-wrapper">
                                {this.props.children}
                            </div>
                        </div>
                    </section>
                </main>
                {this.state.showPopup ?
                    <Popup
                        text={popupMessage}
                        showPopup={this.state.showPopup}
                        togglePopup={this.togglePopup.bind(this)}
                        logOut={this.logOutUser.bind(this)}
                        isIdle={this.props.isIdle}
                    />
                    : null
                }
                {this.props.location.pathname != "/" && !this.props.location.pathname.includes('/home')
                    ?
                    null
                    :
                    <IconLinks selectedSession={this.props.session.selectedSession} />
                }
            </div>
        )
    }
}

export default connect(
    (state) => {
        const { login, nav, session } = state;
        return {
            login,
            nav,
            session
        }
    },
    (dispatch) => {
        return {
            actions: bindActionCreators(Object.assign({}, authActionCreators, navActionCreators, sessionActionCreators), dispatch)
        }
    }
)(Layout)
